/* Pen+Pillar personalization preview.
   Draws the case art and the customer's letters with the same layout
   Anywhere POD uses to make the print file, so the preview matches the case.
   Layout numbers are on Anywhere POD's 500px-wide canvas. */
(function () {
  var fontCache = {};

  function loadFont(name, url) {
    if (!fontCache[name]) {
      var face = new FontFace(name, 'url(' + url + ')');
      fontCache[name] = face.load().then(function (f) { document.fonts.add(f); return f; });
    }
    return fontCache[name];
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function baselineOf(t, size) {
    /* Anywhere POD (its _getTopOffset override) centers the text line (1.13 x size
       tall) in the box only when the line is shorter than the box; otherwise the
       line starts at the top of the box. The baseline sits 0.879 x size below the
       line top. */
    size = size || t.size;
    var room = t.h - size * 1.13;
    return t.tp + (room > 0 ? room / 2 : 0) + size * 0.879;
  }

  /* Anywhere POD's "dynamic sizing" (its doUpdateTextSize): the text is scaled to
     fill its box, as wide as the box allows but never taller than one line
     (font size x 1.13 x 1.16) fits. Short names grow and long names shrink.
     Layers without dynamic sizing keep the template size. */
  var measureCtx = document.createElement('canvas').getContext('2d');
  function fitSize(t, text, fontName) {
    if (!t.fit || !text) return t.size;
    measureCtx.font = '100px "' + fontName + '"';
    var perPx = measureCtx.measureText(text).width / 100;
    return perPx > 0 ? Math.min(t.w / perPx, t.h / (1.13 * 1.16)) : t.size;
  }

  /* Draws the customer's letters onto a product photo already drawn at (0,0,W,H).
     P maps Anywhere POD canvas units to photo fractions (found by matching the photo
     to the print art). The letters go on one patch of the real art that covers the
     sample letters in the photo (widened for long names), color-matched (P.g) and
     feathered at the edges so it blends in. */
  function drawOnPhoto(ctx, W, H, L, P, vals, art, fontName) {
    var m = [P.sx * W, P.sy * W, P.ox * W, P.oy * H];
    var pad = 14, bx0 = 1e9, by0 = 1e9, bx1 = -1e9, by1 = -1e9;
    L.text.forEach(function (t) {
      /* Keep the patch the same size whatever is typed (wide enough for a W or M),
         so the art around the letter never shifts between letters. Fitted text
         always stays inside its box. */
      var v = vals[t.field] || '';
      measureCtx.font = t.size + 'px "' + fontName + '"';
      var tw = t.w;
      if (!t.fit) {
        tw = Math.max(tw, measureCtx.measureText('W').width, measureCtx.measureText('M').width);
        if (v.length > 1) tw = Math.max(tw, measureCtx.measureText(v).width);
      }
      /* Cover the whole text line, not just the box: when the box is shorter than
         the line (Evening Star), the letters hang below it, and a patch sized to the
         box let the sample letter's bottom show through its soft edge. */
      var cx = t.l + t.w / 2, sh = t.sh || { x: 0, y: 0 };
      var lineTop = baselineOf(t, t.size) - t.size * 0.879, lineBottom = lineTop + t.size * 1.13;
      bx0 = Math.min(bx0, cx - tw / 2 - pad + Math.min(0, sh.x)); bx1 = Math.max(bx1, cx + tw / 2 + pad + Math.max(0, sh.x));
      by0 = Math.min(by0, Math.min(t.tp, lineTop) - pad + Math.min(0, sh.y));
      by1 = Math.max(by1, Math.max(t.tp + t.h, lineBottom) + pad + Math.max(0, sh.y));
    });
    var x0 = Math.floor(m[0] * bx0 + m[2]) - 2, y0 = Math.floor(m[1] * by0 + m[3]) - 2;
    var w = Math.ceil(m[0] * (bx1 - bx0)) + 4, h = Math.ceil(m[1] * (by1 - by0)) + 4;
    var o = document.createElement('canvas');
    o.width = w; o.height = h;
    var c = o.getContext('2d');
    c.setTransform(m[0], 0, 0, m[1], m[2] - x0, m[3] - y0);
    c.drawImage(art, L.ax, L.ay, L.aw, L.ah);
    L.text.forEach(function (t) {
      var v = vals[t.field] || '', size = fitSize(t, v, fontName);
      c.font = size + 'px "' + fontName + '"';
      c.fillStyle = t.fill;
      c.textAlign = 'center';
      c.textBaseline = 'alphabetic';
      setShadow(c, t, m[0], m[1]);
      c.fillText(v, t.l + t.w / 2, baselineOf(t, size));
      setShadow(c, null);
    });
    c.setTransform(1, 0, 0, 1, 0, 0);
    var img = c.getImageData(0, 0, w, h), d = img.data, g = (P.g && P.g[0]) || [1, 1, 1];
    var feather = Math.max(3, Math.min(w, h) * 0.12);
    for (var j = 0; j < h; j++) {
      for (var i = 0; i < w; i++) {
        var k = (j * w + i) * 4, e = Math.min(i, j, w - 1 - i, h - 1 - j);
        d[k] = Math.min(255, d[k] * g[0]);
        d[k + 1] = Math.min(255, d[k + 1] * g[1]);
        d[k + 2] = Math.min(255, d[k + 2] * g[2]);
        d[k + 3] = Math.round(255 * Math.min(1, Math.max(0, (e - 2) / feather)));
      }
    }
    c.putImageData(img, 0, 0);
    ctx.drawImage(o, x0, y0);
  }

  /* Some letters have a hard drop shadow in Anywhere POD (Lighthouse, Mariner).
     Canvas shadow offsets ignore the transform, so they are scaled by hand. */
  function setShadow(c, t, kx, ky) {
    var sh = t && t.sh;
    c.shadowColor = sh ? sh.c : 'transparent';
    c.shadowBlur = 0;
    c.shadowOffsetX = sh ? sh.x * kx : 0;
    c.shadowOffsetY = sh ? sh.y * (ky || kx) : 0;
  }

  function thumbKey(variantId, props) {
    return variantId + '|' + Object.keys(props).sort().map(function (k) { return k + '=' + props[k]; }).join('|');
  }

  function saveThumb(key, dataUrl) {
    try {
      var all = JSON.parse(localStorage.getItem('pp-pz-thumbs') || '{}');
      all[key] = { src: dataUrl, t: Date.now() };
      var keys = Object.keys(all).sort(function (a, b) { return all[b].t - all[a].t; });
      keys.slice(25).forEach(function (k) { delete all[k]; });
      localStorage.setItem('pp-pz-thumbs', JSON.stringify(all));
    } catch (e) {}
  }

  function init(box) {
    var cfg = JSON.parse(box.querySelector('script[type="application/json"]').textContent);
    if (cfg.upper) box.classList.add('pp-pz--upper');
    var canvas = box.querySelector('canvas');
    var modelEl = box.querySelector('.pp-pz__model');
    var ctx = canvas.getContext('2d');
    var wrap = box.querySelector('.pp-pz__fields');
    var inputs = cfg.fields.map(function (f, n) {
      var row = document.createElement('label');
      row.className = 'pp-pz__field';
      row.innerHTML = '<span class="pp-pz__label"></span><input class="pp-pz__input" type="text" autocomplete="off" spellcheck="false" required>';
      row.querySelector('span').textContent = f.label;
      var i = row.querySelector('input');
      i.setAttribute('autocapitalize', cfg.upper ? 'characters' : 'words');
      i.setAttribute('data-field', n);
      i.setAttribute('data-sample', f.sample || '');
      if (f.max) { i.maxLength = f.max; i.style.setProperty('--pz-chars', f.max); }
      i.placeholder = f.sample || '';
      wrap.insertBefore(row, wrap.querySelector('.pp-pz__note'));
      return i;
    });
    var section = box.closest('.shopify-section') || document;
    var images = {};
    var current = null;

    /* The page can have several add-to-cart forms for this product (main, sticky bar).
       Copy the letters into each as hidden properties[...] fields. */
    function productForms() {
      return Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
        var idEl = f.querySelector('[name="id"]');
        return idEl && cfg.variants[idEl.value] !== undefined && !/installment/.test(f.className);
      });
    }
    /* Each letter goes in two properties: the readable one (e.g. "Initial") for the
       order page, and Anywhere POD's own _apod-<artwork>-<layer> key, which is what it
       prints from. The artwork depends on the selected model (Slim cases and each
       Kindle have their own), and so do the layer ids. */
    function artOf(v) {
      return (v && cfg.skus && cfg.skus[v.s]) || cfg.art;
    }
    function setHidden(f, name, value) {
      var h = f.querySelector('input[type="hidden"][name="' + name + '"]');
      if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = name; f.appendChild(h); }
      h.value = value;
    }
    function sync() {
      productForms().forEach(function (f) {
        var idEl = f.querySelector('[name="id"]');
        var art = artOf(idEl && cfg.variants[idEl.value]);
        var L = cfg.layouts[art];
        Array.prototype.forEach.call(f.querySelectorAll('input[type="hidden"][name^="properties[_apod-"]'), function (h) { h.remove(); });
        inputs.forEach(function (i, n) {
          var val = i.value.trim();
          var t = L && L.text.filter(function (x) { return x.field === n; })[0];
          setHidden(f, 'properties[' + cfg.fields[n].name + ']', val);
          if (t) setHidden(f, 'properties[_apod-' + art + '-' + t.id + ']', val);
        });
      });
    }
    var latestThumb = null;

    function values() {
      return inputs.map(function (i) { return cfg.upper ? i.value.toUpperCase() : i.value; });
    }
    function props() {
      var p = {};
      inputs.forEach(function (i, n) { p[cfg.fields[n].name] = i.value.trim(); });
      return p;
    }

    function firstEmpty() {
      return inputs.filter(function (i) { return !i.value.trim(); })[0];
    }
    function askToFill(empty) {
      box.classList.add('pp-pz--needs');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      empty.focus({ preventScroll: true });
    }

    /* The Buy with Shop button can't be stopped from page code, so while a field
       is empty an invisible guard sits over it and asks for the personalization. */
    function guardPayButtons() {
      var locked = !!firstEmpty();
      productForms().forEach(function (f) {
        var pb = f.querySelector('.shopify-payment-button');
        if (!pb) return;
        var g = pb.querySelector('.pp-pz-guard');
        if (!g) {
          if (getComputedStyle(pb).position === 'static') pb.style.position = 'relative';
          g = document.createElement('div');
          g.className = 'pp-pz-guard';
          g.setAttribute('aria-hidden', 'true');
          g.style.cssText = 'position:absolute;inset:0;z-index:5;cursor:pointer;background:transparent';
          g.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var empty = firstEmpty();
            if (empty) askToFill(empty);
          });
          pb.appendChild(g);
        }
        g.style.display = locked ? 'block' : 'none';
      });
    }

    document.addEventListener('submit', function (e) {
      if (productForms().indexOf(e.target) < 0) return;
      sync();
      var empty = firstEmpty();
      if (empty) {
        e.preventDefault();
        e.stopImmediatePropagation();
        askToFill(empty);
        return;
      }
      var idEl = e.target.querySelector('[name="id"]');
      var key = thumbKey(idEl.value, props());
      if (latestThumb && latestThumb.key === key) saveThumb(key, latestThumb.src);
      else saveThumb(key, canvas.toDataURL('image/jpeg', 0.85));
    }, true);
    var form = productForms().filter(function (f) { return section.contains(f); })[0] || productForms()[0];

    function variantId() {
      var idEl = form && form.querySelector('[name="id"]');
      return idEl ? idEl.value : '';
    }
    function layoutFor() {
      return cfg.layouts[artOf(cfg.variants[variantId()])] || cfg.layouts[cfg.art];
    }
    function photoLayout(P) {
      return cfg.layouts[P.layout] || cfg.layouts[cfg.art];
    }
    function artFor(L, width) {
      var src = L.art + (L.art.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
      return images[src] || (images[src] = loadImage(src));
    }

    /* Letters on the big product photos: a transparent canvas over each matched photo. */
    function paintGallery() {
      var vals = values();
      var typed = vals.some(function (v) { return v; });
      section.querySelectorAll('.product__media-item[data-media-id]').forEach(function (item) {
        var P = cfg.photos && cfg.photos[item.getAttribute('data-media-id')];
        var img = item.querySelector('img');
        if (!P || !img) return;
        var wrapEl = img.parentElement;
        var cv = wrapEl.querySelector('.pp-pz-photo');
        if (!typed) { if (cv) cv.style.display = 'none'; return; }
        if (!cv) {
          cv = document.createElement('canvas');
          cv.className = 'pp-pz-photo';
          cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:1;display:block';
          if (getComputedStyle(wrapEl).position === 'static') wrapEl.style.position = 'relative';
          wrapEl.appendChild(cv);
        }
        cv.style.display = 'block';
        var L = photoLayout(P);
        var W = Math.round((img.clientWidth || 500) * Math.min(window.devicePixelRatio || 1, 2));
        var H = Math.round(W * (P.ar || 1));
        Promise.all([artFor(L, 1000), loadFont(L.font.name, L.font.url)]).then(function (r) {
          cv.width = W; cv.height = H;
          drawOnPhoto(cv.getContext('2d'), W, H, L, P, values(), r[0], L.font.name);
        });
      });
    }

    /* Small personalized picture for the cart drawer, saved at add-to-cart. */
    function makeThumb() {
      var vid = variantId(), v = cfg.variants[vid];
      var key = thumbKey(vid, props());
      var P = v && cfg.photos && cfg.photos[v.m];
      if (!P) { latestThumb = { key: key, src: canvas.toDataURL('image/jpeg', 0.85) }; return; }
      var L = photoLayout(P);
      Promise.all([loadImage(P.src + '&width=400'), artFor(L, 1000), loadFont(L.font.name, L.font.url)]).then(function (r) {
        var c = document.createElement('canvas');
        c.width = 400; c.height = Math.round(400 * (P.ar || 1));
        var x = c.getContext('2d');
        x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height);
        x.drawImage(r[0], 0, 0, c.width, c.height);
        drawOnPhoto(x, c.width, c.height, L, P, values(), r[1], L.font.name);
        latestThumb = { key: key, src: c.toDataURL('image/jpeg', 0.85) };
      }).catch(function () {
        latestThumb = { key: key, src: canvas.toDataURL('image/jpeg', 0.85) };
      });
    }

    function drawModelPhoto(P, cssW, dpr) {
      var L = photoLayout(P);
      var ar = P.ar || 1;
      /* Crop to the case: the whole art, or the printed panel when the art wraps
         past it (the Duo's art runs around the fold, L.crop in canvas units). */
      var cr = L.crop || [0, 0, L.cw, L.ch], pad = L.crop ? 0 : 0.01;
      var fx0 = Math.max(0, P.ox + P.sx * cr[0] - pad), fx1 = Math.min(1, P.ox + P.sx * cr[2] + pad);
      var fy0 = Math.max(0, P.oy + P.sy * cr[1] / ar - pad), fy1 = Math.min(1, P.oy + P.sy * cr[3] / ar + pad);
      var W = 1000, H = Math.round(W * ar);
      var sw = (fx1 - fx0) * W, sh = (fy1 - fy0) * H;
      canvas.width = Math.round(cssW * dpr);
      canvas.height = Math.round(canvas.width * sh / sw);
      canvas.style.aspectRatio = sw + ' / ' + sh;
      current = P;
      var src = P.src + (P.src.indexOf('?') > -1 ? '&' : '?') + 'width=' + W;
      Promise.all([
        images[src] || (images[src] = loadImage(src)),
        artFor(L, 1000),
        loadFont(L.font.name, L.font.url)
      ]).then(function (r) {
        if (current !== P) return;
        var o = document.createElement('canvas');
        o.width = W; o.height = H;
        var x = o.getContext('2d');
        x.fillStyle = '#fff'; x.fillRect(0, 0, W, H);
        x.drawImage(r[0], 0, 0, W, H);
        /* Always patch over the photo's sample letter, so before anything is typed the
           square is blank and it's clear the shopper adds their own. */
        drawOnPhoto(x, W, H, L, P, values(), r[1], L.font.name);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(o, fx0 * W, fy0 * H, sw, sh, 0, 0, canvas.width, canvas.height);
        box.classList.add('pp-pz--ready', 'pp-pz--photo');
        if (values().every(function (v) { return v; })) makeThumb();
      }).catch(function () {
        delete cfg.photos[vNowKey(P)];
        draw();
      });
    }
    function vNowKey(P) {
      for (var k in cfg.photos) if (cfg.photos[k] === P) return k;
      return '';
    }

    function draw() {
      var L = layoutFor();
      if (!L) return;
      var cssW = canvas.clientWidth || 200;
      var dpr = Math.min(window.devicePixelRatio || 1, 3);
      var k = (cssW * dpr) / L.cw;
      canvas.width = Math.round(L.cw * k);
      canvas.height = Math.round(L.ch * k);
      canvas.style.aspectRatio = L.cw + ' / ' + L.ch;

      var vNow = cfg.variants[variantId()];
      if (modelEl) modelEl.textContent = vNow ? vNow.t : '';
      sync();

      /* Show the shopper's own phone or Kindle (the model's mockup photo, cropped to
         the case) so they still see their model after scrolling down to type. */
      var P = vNow && cfg.photos && cfg.photos[vNow.m];
      if (P) { drawModelPhoto(P, cssW, dpr); paintGallery(); return; }
      box.classList.remove('pp-pz--photo');

      current = L;
      Promise.all([
        artFor(L, Math.min(1400, Math.ceil(canvas.width / 100) * 100)),
        loadFont(L.font.name, L.font.url)
      ]).then(function (r) {
        if (current !== L) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(r[0], L.ax * k, L.ay * k, L.aw * k, L.ah * k);
        L.text.forEach(function (t) {
          var input = inputs[t.field];
          var val = input ? input.value : '';
          if (cfg.upper) val = val.toUpperCase();
          var size = fitSize(t, val, L.font.name);
          ctx.font = (size * k) + 'px "' + L.font.name + '"';
          ctx.fillStyle = t.fill;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'alphabetic';
          setShadow(ctx, t, k);
          ctx.fillText(val, (t.l + t.w / 2) * k, baselineOf(t, size) * k);
          setShadow(ctx, null);
        });
        box.classList.add('pp-pz--ready');
        if (values().every(function (v) { return v; })) makeThumb();
      });
      paintGallery();
    }

    inputs.forEach(function (i) {
      i.addEventListener('input', function () {
        var v = i.value;
        if (cfg.upper) v = v.toUpperCase();
        if (cfg.lettersOnly) v = v.replace(/[^A-Za-z]/g, '');
        else v = v.replace(/[^A-Za-z .'&-]/g, '');
        if (v !== i.value) i.value = v;
        if (v) box.classList.remove('pp-pz--needs');
        sync();
        guardPayButtons();
        draw();
      });
    });

    section.addEventListener('change', function () { setTimeout(draw, 30); });
    if (form) {
      var idEl = form.querySelector('[name="id"]');
      if (idEl) new MutationObserver(function () { draw(); }).observe(idEl, { attributes: true, attributeFilter: ['value'] });
    }
    window.addEventListener('resize', function () { clearTimeout(box._t); box._t = setTimeout(draw, 150); });
    /* A model change re-renders the gallery with that model's photos (product-gallery-media-ids);
       put the letters on the new photos once they arrive. */
    var galleryHost = section.querySelector('[id^="MediaGallery-"]');
    if (galleryHost && galleryHost.parentElement) {
      new MutationObserver(function () {
        clearTimeout(box._g);
        box._g = setTimeout(function () {
          var fresh = [].some.call(section.querySelectorAll('.product__media-item[data-media-id]'), function (item) {
            var img = item.querySelector('img');
            return cfg.photos && cfg.photos[item.getAttribute('data-media-id')] && img && !img.parentElement.querySelector('.pp-pz-photo');
          });
          if (fresh) paintGallery();
        }, 60);
      }).observe(galleryHost.parentElement, { childList: true, subtree: true });
    }
    guardPayButtons();
    draw();
  }

  function boot() {
    document.querySelectorAll('.pp-pz:not([data-ready])').forEach(function (b) {
      b.setAttribute('data-ready', '');
      init(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
